
import { defineComponent, ref } from 'vue';
import { useStripe, StripeElement } from 'vue-use-stripe';
import '@stripe/stripe-js';
import PsModal from '@/components/core/modals/PsModal.vue';
import PsLabelHeader4 from '@/components/core/label/PsLabelHeader4.vue';
import PsErrorDialog from '@/components/core/dialog/PsErrorDialog.vue';
import PsButton from '@/components/core/buttons/PsButton.vue';
import PsLoadingDialog from '@/components/core/dialog/PsLoadingDialog.vue';
import { PsValueProvider } from '@/store/modules/core/PsValueProvider';

export default defineComponent({
    components: { 
        StripeElement,
        PsModal,
        PsLabelHeader4,
        PsButton,
        PsLoadingDialog,
        PsErrorDialog
    },
    setup() {
        const psmodal = ref();
        let okClicked: Function;
        let cancelClicked: Function;

        function actionClicked(status) {
            if(status == 'no') {
                cancelClicked();
            }
            psmodal.value.toggle(false);
        }

        function openModal( okClickedAction: Function, cancelClickedAction: Function){
            psmodal.value.toggle(true);
            okClicked = okClickedAction;
            cancelClicked= cancelClickedAction;        
        }

        //for stripe payment
        const event = ref();
        const stripe_publisbed_key = PsValueProvider.psValueHolder.publishKey;
        const {
        stripe,
        elements: [cardElement],
        } = useStripe({
        key: stripe_publisbed_key || '',
        elements: [{ type: 'card', options: {} }],
        });
   
        const registerCard = () => {
            if (event.value != null &&
                event.value?.complete != null &&
                event.value?.complete!) {
                stripe.value?.elements().create('card');
            
                stripe.value?.createToken(cardElement.value).then(function(result) {
                    // Handle result.error or result.token
                    localStorage.paymentNonce = result.token?.id;
                    okClicked()
                });
                
            }
        }

        return {
            psmodal,
            openModal,
            actionClicked,
            event,
            cardElement,
            registerCard,
        }
    },
})
